import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {JiraTaskComponent} from "./jira-task/jira-task.component";

const routes: Routes = [
  {path: '', component: JiraTaskComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
